import { toastr } from 'react-redux-toastr'
import httpAuth from '../../services/httpAuth'
import { setBonusAmount, setLockedBonus } from './lockedBonus.slice'
import { BASE_URL, getHostnameFromURL } from '../../config/api.config'
import { setBonusLoading, setBonusRules } from './RulesBonus'

export const requestLockedBonus = (data) => async (dispatch, getState) => {
  const checkAuth = getState().auth

  if (checkAuth) {
    try {
      const response = await httpAuth.post(`user/getLockedBonusProgress`, {
        ...(data && { ...data }),
      })
      if (response) {
        if (response.data.data) {
          dispatch(setLockedBonus(response.data.data))
        } else {
          toastr.error(response?.data?.msg || response?.msg)
        }
        return response
      } else {
        toastr.error('Unable To Get Locked Bonus')
      }
    } catch (e) {
      toastr.error('Something Went Wrong !')
    }
  }
}
export const requestBonusAmount = (name) => async (dispatch, getState) => {
  const checkAuth = getState().auth

  if (checkAuth) {
    try {
      const response = await httpAuth.post(`/user/getBonusAmounts`)
      if (response.data) {
        dispatch(setBonusAmount(response?.data?.data))
      }
      return response
    } catch (e) {
      console.error(e)
      dispatch(setBonusAmount({}))
    }
  }
}

export const requestbonusrules = (type) => async (dispatch, getState) => {
  const checkAuth = getState().auth

  if (checkAuth) {
    dispatch(setBonusRules({}))
    try {
      dispatch(setBonusLoading(true))
      const response = await httpAuth.get(
        // `/content/contentGet?content_type=bonus_rules&category=${type}&host=${"royal365.co"}`,
        `/content/contentGet?content_type=bonus_rules&category=${type}&host=${getHostnameFromURL(
          BASE_URL
        )}`
      )
      if (response.data) {
        dispatch(setBonusRules(response?.data?.data))
      }
      return response
    } catch (e) {
      console.error(e)
      dispatch(setBonusRules({}))
    } finally {
      dispatch(setBonusLoading(false)) // stop loading
    }
  }
}
